import './Footer.scss';

import { LegalFooter } from '@amzn/awscat-cookie-management';
import { useContext } from 'react';

import { CookieConsentContext } from './contexts/CookieConsentContext';

function Footer() {
    const getBuildVersion = () => {
        return 'development';
    };

    const { customizeCookies } = useContext(CookieConsentContext);
    return (
        <LegalFooter
            privacyText='Privacy'
            siteTermText='Site terms'
            cookiePreferenceText='Cookie preferences'
            onCookiePreferenceClick={customizeCookies}
            buildVersion={getBuildVersion()}
            contactEmail='proserve-mpa-tool@amazon.com'
        />
    );
}

export default Footer;
